<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="select" label="所属类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="input" label="参数名称" name="parameter_name"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_param_add" color="sys" @click="add">新增商品参数</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="参数名称"
					name="parameter_name"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="参数类型"
					name="parameter_type"
					width="80"
				>
					<template v-slot="{data}">
						{{paramTypeMap[data.parameter_type]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="参数值"
					name="parameter_values"
					width="300"
				></c-table-column>
				
				<c-table-column
					label="所属类目"
					name="type_full_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="是否显示"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.is_display == 2" style="color:green">显示</span>
						<span v-else style="color:gray">隐藏</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="是否必填"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.required_flag == 1" style="color:gray">非必填</span>
						<span v-else style="color:red">必填</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					power="b_product_param_sort"
					@sort="sortHandle"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button power="b_product_param_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_product_param_del" @click="del(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="editDialog" :title="editState ? '编辑商品参数' : '新增商品参数'" width="600" @resolve="submit">
			<c-form ref="editForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="hidden" name="type" value="1"></c-form-item>
				<c-form-item type="input" label="参数名称" name="parameter_name" required></c-form-item>
				<c-form-item v-model="paramType" type="select" label="参数类型" name="parameter_type" :options="paramTypeOptions" required></c-form-item>
				<c-form-item v-show="paramType != 'text'" type="textarea" label="参数值" name="parameter_values" required word="使用英文逗号分隔" :inline-word="false"></c-form-item>
				<c-form-item type="select" label="所属类目" name="product_type_id" options="PRODUCT_CLASSIFY" required></c-form-item>
				<c-form-item type="radio" label="是否显示" name="is_display" :options="displayOptions" required word="是否在商品详情参数表格中显示"></c-form-item>
				<c-form-item type="radio" label="是否必填" name="required_flag" :options="requiredOptions" required></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_product_param',
		
		data() {
			return {
				paramType: '',
				paramTypeOptions: [{
					name: '文本框',
					value: 'text'
				}, {
					name: '下拉框',
					value: 'select'
				}, {
					name: '单选框',
					value: 'radio'
				}, {
					name: '复选框',
					value: 'checkbox'
				}],

				paramTypeMap:{'text': '文本框','select': '下拉框','radio': '单选框','checkbox': '复选框'},
				
				displayOptions: [{
					name: '是',
					value: 2
				}, {
					name: '否',
					value: 1
				}],
				
				requiredOptions: [{
					name: '是',
					value: 2
				}, {
					name: '否',
					value: 1
				}],
				
				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.type = 1;
				this.$refs.table.load({
					url: '/product_param/list',
					data
				});
			},
			
			add() {
				this.editState = false;
				this.$refs.editForm.clear();
				this.$refs.editForm.set({type:1,parameter_type:'select',is_display:2,required_flag:1});
				this.$refs.editDialog.open();
			},
			
			edit(val) {
				this.editState = true;
				this.$refs.editForm.set(val);
				this.$refs.editDialog.open();
			},

			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.parameter_name+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product_param/remove',
							data: {type:1,id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			sortHandle(row, type, next) {
				//row.prev() 上一行数据
				//row.next() 下一行数据
				let submitData ={};
				submitData.type = 1
				if(type=='top' || type=='bottom'){
					submitData.sort_type = type;
					submitData.id = row.data.id;
				}
				if(type=='up'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.prev().data.id;
				}
				if(type=='down'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.next().data.id;
				}
				this.request({
					url: '/product_param/sort',
					data: submitData,
					loading: true,
					success: data => {
						next();
					}
				});
			},
			
			submit(stop) {
				stop();
				this.$refs.editForm.submit({
					url: this.editState ? '/product_param/edit' : '/product_param/add',
					rule: {
						parameter_name: '请填写参数名称',
						parameter_type: '请选择参数类型',
						parameter_values: [{
							type: 'empty',
							word: '请填写参数值',
							skip: data => {
								return data.parameter_type == 'text';
							}
						}],
						product_type_id: '请选择所属类目',
						is_display: '请选择是否显示',
						required_flag: '请选择是否必填'
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.update();
						this.$refs.editDialog.close();
					}
				});
			}
		}
	}
</script>